<template>
  <div id="pass-reset-fields">
    <div id="user-login-wrap" v-if="currUser.value !== ''">
      <label for="user-login">{{ passStrings['UserLabel'] }}</label>
      <div>
        <input type="text" name="username" id="user-login" readonly="readonly" class="input"
               :value="currUser" autocomplete="username" required="required" @change="$event.target.value = currUser">
      </div>
    </div>
    <div class="user-pass1-wrap">
      <label for="password" id="pass1-label">{{ passStrings['New'] }}</label>
      <div class="wp-pwd">
        <input type="password" name="password" id="pass1" class="input password" autocomplete="new-password"
               :placeholder="passStrings['New']" value="" required="required">
        <button @click="toggleVfy" type="button" class="button button-secondary wp-hide-pw hide-if-no-js">
          <span class="dashicons dashicons-visibility" aria-hidden="true"></span>
        </button>
      </div>
      <button v-if="showGenButton" id="generate-pass" class="button" type="button">{{ passStrings['GenButton'] }}</button>
    </div>
    <div id="user-pass2-wrap">
      <label for="password-vfy">{{ passStrings['Verify'] }}</label>
      <div>
        <input name="password-vfy" id="pass-vfy" class="input" autocomplete="off"
               :placeholder="passStrings['Verify']" value="" type="password">
      </div>
    </div>
    <rules-container/>
  </div>
</template>

<script setup>
import $ from "jquery";
import {onMounted, ref} from "vue";
import RulesContainer from "./rulesContainer";
const props = defineProps(["currUser"]);

const passStrings = window.NewPassStrings;
let generatedPass = window.GeneratedPass[0];
let showGenButton = ref(true);
let userProfilePresent = false;

onMounted(function() {
  $('#generate-pass').on('click', function() {
    $('#pass1').val(generatedPass);
    $('#pass-vfy').val(generatedPass);
    $.post(passStrings['AjaxUrl'], {
      action: 'generate-password',
    }, function(res) {
      if (res['success']) generatedPass = res['data'];
    });
  });

  // lastpass does not detect content added by the generate-pass button
  hideIfLastPassUser();
  // if user-profile.js has been enqueued by wp,
  // toggling visibility is handled differently
  detectUserProfileJS();
});

function detectUserProfileJS() {
  $('script').each(function() {
    if ($(this).attr('id') === 'user-profile-js') {
      userProfilePresent = true;
    }
  });
}

function toggleVfy() {
  // current type of pass1 (before change)
  let type = $('#pass1').attr('type');
  // this runs before pass1 type is changed, thus do inverse
  if (type === 'text') {
    if (!userProfilePresent) $('#pass1').attr('type', 'password');
    $('#pass-vfy').attr('type', 'password');
  } else {
    if (!userProfilePresent) $('#pass1').attr('type', 'text');
    $('#pass-vfy').attr('type', 'text');
  }
}

function hideIfLastPassUser() {
  const target = document.getElementById("pass-reset-fields");
  const config = {attributes: false, childList: true, subtree: true};
  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      let node = mutation.addedNodes[0];
      // if inserted node is from lastpass, remove generate-pass button
      if (node.outerHTML && node.outerHTML.includes('lastpass')) {
        showGenButton.value = false;
        observer.disconnect();
      }
    }
  };

  // execute callback when mutations are observed
  const observer = new MutationObserver(callback);
  observer.observe(target, config);
}
</script>

<style scoped>
#pass1 {
  margin-bottom: 5px;
  text-overflow: ellipsis;
}

#user-pass2-wrap {
  margin-top: 16px;
}

#pass-vfy {
  margin-bottom: 0;
  text-overflow: ellipsis;
}
</style>